import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounceTime, map, Subject } from 'rxjs';
import { NIGHTWEB_APP_CONSTANT } from 'src/app/constants';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchComponent implements OnInit {
  searchKeyword = new Subject<string>();
  searchKey = '';
  @Input() placeholder: string = 'Search';
  @Output() emitSearchKeyword = new EventEmitter<any>();

  @Input()
  set initialKeyword(value: string | null | undefined) {
    const next = value ?? '';
    if (next !== this.searchKey) {
      this.searchKey = next;
    }
  }

  constructor() {
    this.searchKeyword
      .pipe(
        map((event) => event),
        debounceTime(NIGHTWEB_APP_CONSTANT.debounceTime)
      )
      .subscribe((value) => {
        this.searchKey = value;
        return this.filter(value);
      });
  }

  ngOnInit(): void {}

  filter(value: any) {
    this.emitSearchKeyword.emit(value);
  }
}
